import * as React from "react";
import type { SVGProps } from "react";
const SvgSystemExchangeAppIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="system_exchange_app_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M147.2 149.333c-22.4 0-40.533 19.115-40.533 42.667s18.133 42.667 40.533 42.667h729.6c22.4 0 40.533-19.115 40.533-42.667S899.2 149.333 876.8 149.333H147.2zm277.845 320C402.347 469.333 384 488.448 384 512s18.347 42.667 41.045 42.667h451.243c22.699 0 41.045-19.115 41.045-42.667s-18.346-42.667-41.045-42.667H425.045zM106.667 832c0-23.552 18.133-42.667 40.533-42.667h729.6c22.4 0 40.533 19.115 40.533 42.667S899.2 874.667 876.8 874.667H147.2c-22.4 0-40.533-19.115-40.533-42.667zM266.24 487.125l-116.48-97.152c-12.075-10.069-29.013-7.082-37.845 6.656a33.792 33.792 0 0 0-5.206 18.176v194.39c0 17.024 12.118 30.805 27.051 30.805a24.917 24.917 0 0 0 16-5.973l116.523-97.152c12.074-10.07 14.677-29.355 5.845-43.094a29.312 29.312 0 0 0-5.845-6.656z"
    />
  </svg>
);
export default SvgSystemExchangeAppIcon;
